import PropTypes from 'prop-types';
import {generateTaskWellsLocation} from '../PoolingTaskHelper';

function PoolingTaskDescription({number, labware, tasks, labwareState}) {
  return (
    <>
      &nbsp;
      <span>{number === 3 ? 'to' : 'from'}</span>
      &nbsp;
      <span>{generateTaskWellsLocation(number, labware, tasks, labwareState)}</span>
    </>
  );
}

PoolingTaskDescription.propTypes = {
  number: PropTypes.number,
  labware: PropTypes.object,
  labwareState: PropTypes.object,
  tasks: PropTypes.array,
};

PoolingTaskDescription.defaultProps = {
  number: 0,
  labware: {},
  labwareState: {},
  tasks: [],
};

export default PoolingTaskDescription;
